<template>
  <div class="admin-area">
    <div class="row">
      <div class="col-lg-12 text-right" v-if="user && user.first_name">
        <button class="btn btn-danger mb-3" @click="logout">{{ user.first_name + ' ' + user.last_name }} Kijelentkezés</button>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);

import VuetifySnackbarQueue from 'vuetify-snackbar-queue'
import {mapGetters} from "vuex";
Vue.use(VuetifySnackbarQueue);

import VuejsDialog from 'vuejs-dialog';
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
Vue.use(VuejsDialog, {
  html: true,
  loader: true,
  okText: 'Igen',
  cancelText: 'Mégsem',
  animation: 'bounce'
});

import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing);

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true
});

export default {
  name: 'AdminLayout',
  data(){
    return{
      message: this.getMessage ? this.getMessage : [],
      displaySnackbar: true,
      messageTimeout: 4000,
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'getMessage'
    ]),
  },
  methods: {
    removeItem (id) {
      this.$store.commit('clearMessage');
    },
    onLoggedOut() {

    },
    logout() {
        this.$store.dispatch('logout').then((resp) => {
          this.$router.push({
            path: '/a/login'
          })
        });
    },
    showToast(message, type) {
      let toast = this.$toast;

      switch(type) {
        case 'success':
          toast = this.$toast.success;
          break;
        case 'error':
          toast = this.$toast.error;
          break;
        case 'info':
          toast = this.$toast.info;
          break;
        default:
          toast = this.$toast;
          break;
      }

      toast(message, {
        position: "top-center",
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false
      });
    }
  },
  watch: {
    getMessage: function(newVal) {
      this.message = newVal && newVal.length > 0 ? newVal[0] : null;

      if(this.message && this.message.message) {
        this.showToast(this.message.message, this.message.type);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.admin-area {
  padding: 32px;
}
</style>
